import { IAddressBase } from '../../models/address';
import { IUserCategoryBase } from '../../models/userCategories';
import {
  IUserAddressBase,
  IUserAssignmentBase,
  IUserBase,
  UserGender,
} from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUserAssignment extends IUserAssignmentBase {
  venture?: IVentureBase;
}

export interface INewUser extends IUserBase {
  address?: IUserAddressBase;
  categories: IUserCategoryBase[];
  userAssignments: IUserAssignment[];
}

interface ICreateEmployeeUsersService {
  address?: IAddressBase;
  bio?: string;
  birthDate?: Date;
  cpf?: string;
  email: string;
  featureGroupId: string;
  gender?: UserGender;
  name: string;
  phone?: string;
  venturesId?: string[];
}
export const createEmployeeUsersService = async ({
  address,
  bio,
  birthDate,
  cpf,
  email,
  featureGroupId,
  gender,
  name,
  phone,
  venturesId,
}: ICreateEmployeeUsersService): Promise<INewUser> => {
  const { data } = await jhsfBookingsApi.post<INewUser>('/users/employees', {
    address,
    bio,
    birthDate,
    cpf,
    email,
    featureGroupId,
    gender,
    name,
    phone,
    venturesId,
  });

  return data;
};
